export const SUPPORTS_ARRAY_PROTOTYPE_KEYS = "keys" in Array.prototype;
